import { useState, useEffect, useRef } from "react";
import Ajustes from "../../assets/img/svg/users/opciones.svg";
import Editar from "../../assets/img/svg/users/editar.svg";
import Eliminar from "../../assets/img/svg/users/eliminar.svg";
import TablaMRT from "../../features/table/RTable";
import Popper from "@mui/material/Popper";
import { headCellCenterAlign } from "../../utils/columnStyles";
import { customStringFilter } from "../../features/table/filterFunctions";
import EDTModal from "../../features/edtModal/EDTModal";
import {
  getReporteTipoParametrosTrabajo,
  updateTipoTrabajo,
  deleteTipoTrabajo,
} from "../../components/functions/Projects";
import EDTModalEditar from "../../features/edtModal/EDTModalEditar";
import ConfirmDialog from "../../features/imagenesModal/dialogs/ConfirmDialog";
import { useNavigate } from "react-router-dom";
import Anadir from "../../assets/img/svg/anadir.svg";
import CustomButton from "../../ui/button/Button";
import { headCellLeftAlign } from "../../utils/columnStyles";

const EDTs = ({ typeWorks, API_URL, user }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(typeWorks || []);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [selectedEDT, setSelectedEDT] = useState(null);
  const [openEditarModal, setOpenEditarModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const rowIconRef = useRef([]);

  useEffect(() => {
    setData(typeWorks);
  }, [typeWorks]);

  const toggleMenuOptions = (index) => {
    setOpenMenuIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleDownloadReporte = async (id) => {
    try {
      const response = await getReporteTipoParametrosTrabajo(API_URL, id);
      console.log("🚀 ~ handleDownloadReporte ~ response:", response);
      window.open(
        `https://check-dev.gruponxt.dev/nxt/api/descargar-reporte-tipo-parametros-trabajo/${id}`,
        "_blank"
      );
    } catch (error) {
      console.error("Error al obtener el reporte:", error);
    }
  };

  const columns = [
    {
      accessorKey: "nombre",
      header: "Nombre",
      filterFn: customStringFilter,
      width: 150,
      muiTableHeadCellProps: {
        sx: headCellLeftAlign,
      },
    },
    {
      id: "sub-menu",
      header: " ",
      width: 50,
      muiTableHeadCellProps: {
        sx: headCellCenterAlign,
      },
      Cell: ({ row }) => {
        return (
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <button
              ref={(el) => (rowIconRef.current[row.index] = el)}
              onClick={(e) => {
                e.stopPropagation();
                toggleMenuOptions(row.index);
              }}
              className="action-icon"
            >
              <img
                src={Ajustes}
                alt="Ajustes"
                style={{ width: "20px", height: "20px" }}
              />
            </button>

            <Popper
              open={openMenuIndex === row.index}
              anchorEl={rowIconRef.current[row.index]}
              placement="bottom-start"
              style={{ zIndex: 999 }}
            >
              <div
                className="dropdown-menu-user"
                style={{
                  background: "white",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  padding: "8px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
              >
                {/* <p
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownloadReporte(row.original.id);
                  }}
                  style={{ cursor: "pointer", margin: 0 }}
                >
                  <img src={Editar} alt="" style={{ marginRight: "8px" }} />
                  Descargar Reporte de Parámetros
                </p>
                <p onClick={() => {}} style={{ cursor: "pointer", margin: 0 }}>
                  <img src={Editar} alt="" style={{ marginRight: "8px" }} />
                  Descargar Reporte de Categorías de Imagen
                </p> */}
                <p
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedEDT(row.original);
                    setOpenEditarModal(true);
                  }}
                  style={{ cursor: "pointer", margin: 0 }}
                >
                  <img src={Editar} alt="" style={{ marginRight: "8px" }} />
                  Editar
                </p>
                <p
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedEDT(row.original);
                    setShowConfirm(true);
                  }}
                  style={{ cursor: "pointer", margin: 0 }}
                >
                  <img src={Eliminar} alt="" style={{ marginRight: "8px" }} />
                  Borrar
                </p>
              </div>
            </Popper>
          </div>
        );
      },
    },
  ];

  const options = {
    enableColumnFilters: false,
    enableSorting: true,
    enablePagination: true,
    getRowId: (originalRow) => originalRow.id,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        setSelectedEDT(row.original);
        setOpenModal(true);
      },
      sx: {
        cursor: "pointer",
      },
    }),
  };

  const editarEDT = async (nombre) => {
    try {
      const newEDT = { ...selectedEDT, nombre };
      await updateTipoTrabajo(API_URL, newEDT);
      const updatedEDT = data.find((edt) => edt.id === newEDT.id);
      updatedEDT.nombre = newEDT.nombre;
      const newData = [...data];
      const index = newData.findIndex((edt) => edt.id === newEDT.id);
      newData[index] = updatedEDT;
      setData(newData);
    } catch (error) {
      console.error("Error al actualizar el EDT:", error);
    } finally {
      setOpenEditarModal(false);
      setSelectedEDT(null);
    }
  };

  const eliminarEDT = async () => {
    try {
      await deleteTipoTrabajo(API_URL, selectedEDT.id);
      const newData = data.filter((edt) => edt.id !== selectedEDT.id);
      setData(newData);
    } catch (error) {
      console.error("Error al eliminar el EDT:", error);
    } finally {
      setOpenModal(false);
      setSelectedEDT(null);
    }
  };

  return (
    <>
      <ConfirmDialog
        open={showConfirm}
        title="Confirmación"
        content="Está seguro que desea borrar este tipo de trabajo?"
        onClose={() => setShowConfirm(false)}
        onConfirm={() => {
          setShowConfirm(false);
          eliminarEDT();
        }}
      />
      <EDTModal
        selectedEDT={selectedEDT}
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setSelectedEDT(null);
        }}
        API_URL={API_URL}
        user={user}
      />
      <EDTModalEditar
        selectedEDT={selectedEDT}
        open={openEditarModal}
        onClose={() => {
          setOpenEditarModal(false);
          setSelectedEDT(null);
        }}
        onConfirm={editarEDT}
      />
      <div style={{ display: "flex", height: "100%" }}>
        <div style={{ flex: 1, padding: "10px", width: "80%" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "16px",
            }}
          >
            <h2 style={{ margin: 0 }}>Estructuras de desgloce de trabajo</h2>
            {user?.perfil?.esAdministrador && (
              <CustomButton
                background="#62C776"
                width="126px"
                height="31px"
                fontSize="14px"
                color="#FFFFFF"
                text="Nuevo EDT"
                fontWeight={700}
                fontStyle="normal"
                border={0}
                icon={true}
                src={Anadir}
                iconW="12px"
                iconM="5px"
                onClick={() => navigate("/proyectos/edts/nuevo")}
              />
            )}
          </div>
          <TablaMRT columns={columns} data={data} options={options} />
        </div>
      </div>
    </>
  );
};

export default EDTs;
